import { atom } from "jotai";
import { Notes } from "../data/models/ContractTypes";

export const notesState = atom<Notes>({
  notes: "",
});
